var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.166 21a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0ZM14 17.5H4.666l.019-11.667H17.5L17.48 17.5H14ZM8.166 21a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0Zm15.167-6.44v2.94h-3.5v-5.739l3.5 2.799Zm1.896-1.471-5.396-4.317V5.833c0-1.287-.948-2.333-2.115-2.333H4.447c-1.165 0-2.114 1.046-2.114 2.333V17.5c0 1.018.599 1.877 1.425 2.196A3.466 3.466 0 0 0 3.5 21c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-.412-.084-.8-.216-1.167h7.431A3.43 3.43 0 0 0 17.5 21c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-.412-.084-.8-.216-1.167h.216c.645 0 1.166-.521 1.166-1.166V14c0-.355-.16-.69-.437-.911Z",
    fill: "#008545"
  })));
};
export default SvgTruck;